import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import type { TriggerRunStatus } from "@/types/process-trigger.types";

const STATUS_STYLES: Record<TriggerRunStatus, string> = {
  AWAITING_USER: "bg-amber-50 text-amber-800 border-amber-200",
  STARTED: "bg-green-50 text-green-800 border-green-200",
  DECLINED: "bg-gray-100 text-gray-700 border-gray-200",
  EXPIRED: "bg-red-50 text-red-700 border-red-200",
  CANCELLED: "bg-gray-100 text-gray-700 border-gray-200",
  SKIPPED: "bg-slate-50 text-slate-600 border-slate-200",
};

const RunStatusBadge: React.FC<{ status: TriggerRunStatus; overdue?: boolean }> = ({
  status,
  overdue,
}) => {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        overdue ? STATUS_STYLES.EXPIRED : STATUS_STYLES[status]
      )}
    >
      {overdue ? t("processTriggers.status.overdue") : t(`processTriggers.status.${status}`)}
    </span>
  );
};

export default RunStatusBadge;
